import React, { useState, useRef, useEffect } from 'react';
import { useStateValue } from './StateProvider';
import Title from './Title';
import Select from './Components/select.js';
import configData from './Config';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import { unitsofmeasurement, getOrderCost, getOrderPrice } from './Utils/items.js';

import './POS.css';

export const tableStatus = [
    { key: 'free', name: 'Free', color: '#4CAF50' },
    { key: 'occupied', name: 'Occupied', color: '#F44336' },
    { key: 'notavailable', name: 'Not Available', color: '#9E9E9E' },
    { key: 'reserved', name: 'Reserved', color: '#FFC107' },
    { key: 'cleaning', name: 'Cleaning', color: '#03A9F4' },
];

const navItems = [
    { key: 'order', icon: '🛒', label: 'Order' },
    { key: 'tables', icon: '🍽️', label: 'Tables' },
    { key: 'customers', icon: '👥', label: 'Customers' },
    { key: 'checkout', icon: '💳', label: 'Checkout' },
    { key: 'register', icon: '💰', label: 'Register' },
    { key: 'kds', icon: '🍳', label: 'Kitchen Display' },
    { key: 'history', icon: '📜', label: 'History' },
];

const navItemsKitchen = [
    { key: 'kds', icon: '📜', label: 'Kitchen Operations' },
];

function POSNavBar({ module, setModule }) {
    return (
        <div className='posnavbar'>
            {navItems.map(item => (
                <div
                    key={item.key}
                    onClick={() => setModule(item.key)}
                    className={module == item.key ? 'posnavbar_item posnavbar_itemactive' : 'posnavbar_item'}
                >
                    <div className='posnavbar_itemicon'>{item.icon}</div>
                    <div className='posnavbar_itemlabel'>{item.label}</div>
                </div>
            ))}
        </div>
    );
}

function POS({ state, setState }) {
    const [{ project }, dispatch] = useStateValue();
    const [order, setOrder] = useState([]);
    const [tables, setTables] = useState([
        { id: 1, name: 'Table 1', status: 'free', order: [], x: 50, y: 80 },
        { id: 2, name: 'Table 2', status: 'occupied', order: [], x: 200, y: 60 },
        { id: 3, name: 'Table 3', status: 'free', order: [], x: 120, y: 100 },
        { id: 4, name: 'Table 4', status: 'occupied', order: [], x: 300, y: 130 }
    ]);
    const [transactions, setTransactions] = useState([]);
    const [salesinvoices, setSalesinvoices] = useState([]);
    const [checkout, setCheckout] = useState({});
    const [module, setModule] = useState('order');

    const postype = project?.pos?.type || '';

    function renderModule() {
        switch (module) {
            case 'order':
                return <Order order={order} setOrder={setOrder} />;
            case 'tables':
                return <Tables tables={tables} setTables={setTables} />;
            case 'checkout':
                return <Checkout order={order} setOrder={setOrder} />;
            case 'register':
                return <Register salesinvoices={salesinvoices} transactions={transactions} />;
            case 'history':
                return <History />;
            case 'salesinvoices':
                return <SalesInvoices salesinvoices={salesinvoices} />;
            case 'kds':
                return <KitchenDisplay />;
            default:
                return null;
        }
    };

    function Order() {
        const [itemid, setItemid] = useState('');

        const orderprice = getOrderPrice(
            project.items,
            order,
            project.exchangerates,
            project.basecurrency
        )

        const printRef = useRef();

        const handleClear = () => {
            setOrder([])
        }

        const handleRemoveItem = (index) => {
            setOrder(prev => prev.filter((_, i) => i !== index));
        };

        const totalsByCurrency = [];

        order.forEach(i => {
            const currency = i.itemcurrency || 'Unknown';
            const subtotal = i.itemprice * i.itemquantity;
            const existing = totalsByCurrency.find(t => t.currency === currency);

            if (existing) {
                existing.total += subtotal;
            } else {
                totalsByCurrency.push({ currency: currency, total: subtotal });
            }
        });

        const handleCheckout = () => {
            setModule('checkout')
        }

        const handleAddOrder = (itemid) => {
            const item = project?.items?.find(i => i.id === itemid);
            if (!item) return;
            const price = parseFloat(item.pricing[0]?.priceamount) || 0;
            const currencyid = item.pricing[0]?.pricecurrencyid
            const currencysymbol = project?.currencies?.find(c => c.id == currencyid)?.symbol;

            setOrder(prev => {
                const exists = prev.find(p => p.id === item.id);
                if (exists) return prev.map(p => p.id === item.id ? { ...p, itemquantity: p.itemquantity + 1 } : p);
                return [...prev, {
                    id: item.id,
                    name: item.name,
                    itemprice: price,
                    itemquantity: 1,
                    itemcurrency: currencysymbol,
                    itemunityofmeasurement: item.unitofmeasurement
                }];
            });
        };

        return (
            <div>
                <div className='pos_order_header'>

                </div>

                <div className='pos_order_barcode'>

                </div>

                <div className='pos_order_items'>
                    <table className='modal_table'>
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Total</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {order.map((item, index) => {
                                let quantityuom = unitsofmeasurement.find(uom => uom.id == item.itemunityofmeasurement)?.name;
                                return (
                                    <tr key={item.id}>
                                        <td><div>{item.name}</div></td>
                                        <td><div>{item.itemquantity} {quantityuom}</div></td>
                                        <td><div>{item.itemcurrency} {item.itemprice.toLocaleString('en')}</div></td>
                                        <td><div>{item.itemcurrency} {(item.itemprice * item.itemquantity).toLocaleString('en')}</div></td>
                                        <td><div className='modal_removeitembutton' onClick={() => handleRemoveItem(index)}>&minus;</div></td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                <div className='pos_order_summary' ref={printRef}>
                    {project.projectdetailsimage && (
                        <img
                            className="pos_invoice_projectdetailsimage"
                            src={project.projectdetailsimage}
                            alt="Project Details Image"
                        />
                    )}
                    <div className='modal_row'>
                        <div className='pos_invoice_projectname'>{project.name}</div>
                    </div>
                    {
                        order.length != 0 &&
                        <table className='pos_invoice_table'>
                            <thead>
                                <tr>
                                    <th>Unit</th>
                                    <th>Item</th>
                                    <th>Price</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {order.map((item, index) => {
                                    const quantityuom = unitsofmeasurement.find(uom => uom.id == item.itemunityofmeasurement)?.name;
                                    return (
                                        <tr key={'order' + index}>
                                            <td>{item.itemquantity} {quantityuom}</td>
                                            <td>{item.name}</td>
                                            <td>
                                                {item.itemcurrency}{' '}
                                                {Number(item.itemprice).toLocaleString('en')}
                                            </td>
                                            <td>
                                                {item.itemcurrency}{' '}
                                                {(item.itemprice * item.itemquantity).toLocaleString('en')}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={3}>Total</td>
                                    <td>{orderprice}</td>
                                </tr>
                            </tfoot>
                        </table>
                    }
                    <h4>Thank you.</h4>
                    <h4>Powered by {configData.APPNAME}</h4>
                </div>
            </div >
        );
    }

    function Checkout({ order }) {
        const [amount, setAmount] = useState(0);
        const [currencyid, setCurrencyid] = useState(project.basecurrency);
        const [payment, setPayment] = useState({
            currencyid: "",
            method: "cash",
            account: "",
            reference: "",
        });

        useEffect(() => {
            let price = getOrderPrice(
                project.items,
                order,
                project.exchangerates,
                project.basecurrency
            )
            setAmount(price || 0)
        }, [project.items, order, project.exchangerates, project.basecurrency]);

        const handleChange = (field, value) => {
            setPayment(prev => ({ ...prev, [field]: value }));
        };

        const handleSubmit = () => {
            const trans = {
                id: "",
                type: "receipt",
                ts: Math.floor(Date.now() / 1000),
                name: "Payment",
                fromtype: "client",
                from: "JEMShQiL",
                totype: "cash",
                to: "7kqno3fR",
                beneficiarytype: "",
                beneficiaryid: "",
                subaccountid: "JNIxcNPD",
                amount: payment.amount,
                currencyid: payment.currencyid
            };
            setTransactions([...transactions, trans])
            setSalesinvoices([...salesinvoices, order])
            setOrder([]);
            setModule('order');
        };

        const paymentMethods = [
            "cash",
        ];

        return (
            <div className="">
                <div className='modal_row'>
                    <div className='modal_rowsection'>
                        {JSON.stringify(order)}
                    </div>
                </div>
                <div className='modal_row'>
                    <div className='modal_rowsection'>
                        <input
                            className='modal_input'
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                    </div>
                    <div className='modal_rowsection'>
                        <Select data={project.currencies} itemid={currencyid} setItemid={setCurrencyid} />
                    </div>
                </div>

                <div>
                    <h3 className="text-lg font-medium mb-3">Payment Method</h3>
                    <div className="grid grid-cols-2 gap-2">
                        {paymentMethods.map(method => (
                            <button
                                key={method}
                                onClick={() => handleChange("method", method)}
                                className='modal_button'
                            >
                                {method}
                            </button>
                        ))}
                    </div>
                </div>

                <div className='modal_row'>
                    <div className='modal_rowsection'>
                        <select
                            value={payment.account}
                            onChange={e => handleChange("account", e.target.value)}
                            className="modal_select"
                        >
                            <option value="">Select Account</option>
                            <option value="cash">Cash Register</option>
                            <option value="bank">Bank Account</option>
                            <option value="wallet">Digital Wallet</option>
                        </select>
                    </div>
                </div>

                <div className='modal_row'>
                    <div className='modal_rowsection'>
                        <button
                            onClick={handleSubmit}
                            className='modal_button'
                        >
                            Confirm Payment
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    function Customers() {
    }

    function History() {
    }

    function Tables({ tables, setTables }) {
        const [option, setOption] = useState(null);

        const handleTableAction = (action, table) => {
        };

        function Table({ table }) {
            const [itemid, setItemid] = useState('');
            let currencySymbol = project.currencies.find(curr => curr.id == project.basecurrency)?.symbol;

            let statusName = tableStatus.find(s => s.key === table.status)?.name

            const ordercost = getOrderCost(
                table.order,
                project.purchaseinvoices,
                project.productionorders,
                project.exchangerates,
                project.basecurrency
            )

            const orderprice = getOrderPrice(
                project.items,
                table.order,
                project.exchangerates,
                project.basecurrency
            )

            function TableMenu({ table, setTables }) {

                function Order({ table, setTables }) {
                    const [itemid, setItemid] = useState('');

                    const handleAddOrder = (table, setTable, itemid) => {
                        const item = project?.items?.find(i => i.id === itemid);
                        if (!item) return;

                        const price = parseFloat(item.pricing[0]?.priceamount) || 0;
                        const currencyid = item.pricing[0]?.pricecurrencyid;
                        const currencysymbol = project?.currencies?.find(c => c.id === currencyid)?.symbol;

                        setTables(prevTables =>
                            prevTables.map(t => {
                                if (t.id !== table.id) return t;

                                const existing = t.order?.find(o => o.id === item.id);
                                let updatedOrder;

                                if (existing) {
                                    updatedOrder = t.order.map(o =>
                                        o.id === item.id ? { ...o, itemquantity: o.itemquantity + 1 } : o
                                    );
                                } else {
                                    const newItem = {
                                        id: item.id,
                                        name: item.name,
                                        itemprice: price,
                                        itemquantity: 1,
                                        itemcurrency: currencysymbol,
                                        itemunityofmeasurement: item.unitofmeasurement
                                    };
                                    updatedOrder = [...(t.order || []), newItem];
                                }

                                return { ...t, order: updatedOrder };
                            })
                        );
                    };

                    return (
                        <div className='pos_tablemenumodal'>
                            <div className='modal_rowsection'>
                                <Select data={project.items.filter(item => item.posvisible)} itemid={itemid} setItemid={setItemid} />
                            </div>
                            <div className='modal_rowsection'>
                                <button className="button" onClick={() => handleAddOrder(table, setTables, itemid)} >Add</button>
                            </div>
                        </div>
                    )
                }

                function Status({ table, setTables }) {
                    const handleStatusChange = (table, statusKey) => {
                        setTables(prevTables =>
                            prevTables.map(t =>
                                t.id === table.id ? { ...t, status: statusKey } : t
                            )
                        );
                    };

                    return (
                        <div className='pos_tablemenumodal'>
                            <div className='modal_rowsection'>
                                {tableStatus.map(status => (
                                    <button
                                        key={status.key}
                                        className={`modal_button ${table.status === status.key ? 'active' : ''}`}
                                        onClick={() => handleStatusChange(table, status.key)}
                                    >
                                        {status.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    );
                }

                const handleCheckout = (table) => {
                    setOrder([])
                    setOrder(table.order)
                    setModule('checkout')
                }

                const handleClear = (table) => {

                }

                return (
                    <div className='pos_tablemenumodal'>
                        <div onClick={() => setOption(<Order table={table} setTables={setTables} />)}>Add order</div>
                        <div onClick={() => setOption(<Status table={table} setTables={setTables} />)}>Change status</div>
                        <div onClick={() => handleCheckout(table)}>Checkout</div>
                        <div onClick={() => handleClear(table)}>Clear</div>
                    </div>
                )
            }

            return (
                <div
                    className='pos_table'
                    style={{
                        backgroundColor: tableStatus.find(s => s.key === table.status)?.color || '#ddd',
                        color: '#fff',
                        borderRadius: '12px',
                        padding: '10px',
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    }}
                    onClick={() => setOption(<TableMenu table={table} setTables={setTables} />)}
                >
                    <div className='pos_tablename'>{table.name}</div>
                    <div className='pos_tablestatus'>{statusName}</div>

                    <div className='pos_tableorders'>
                        {table.order.length > 0 && (
                            <ul>
                                {
                                    table.order.map((item, i) => (
                                        <li key={'order' + i}>{item.itemquantity} x {item.name}</li>
                                    ))
                                }
                            </ul>
                        )}
                        <div>
                            Cost: {currencySymbol + ' ' + ordercost}
                        </div>
                        <div>
                            Price:{currencySymbol + ' ' + orderprice}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <button className='modal_button'>Edit</button>
                <div className="pos_tables">
                    {
                        tables.map((table, index) => (
                            <Table
                                key={'table' + index}
                                table={table}
                            />
                        ))
                    }
                </div>
                {option}
            </div>
        );
    }

    function Register() {
        const handleClose = () => {
            if (salesinvoices.length > 0) {
                setModule('salesinvoices')
            }
            if (transactions.length > 0) {
                return
            }
        };

        return (
            <div>
                <div className='modal_row'>
                    <div className='modal_rowsection'>
                        <table className='modal_table'>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Name</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactions.map((t, index) => {
                                    const date = new Date(parseInt(t.ts) * 1000).toLocaleString();
                                    const currency = project.currencies.find(curr => curr.id == t.currencyid)?.symbol
                                    return (
                                        <tr key={"transactions" + index}>
                                            <td>{date}</td>
                                            <td>{t.name}</td>
                                            <td>{currency} {t.amount}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className='modal_row'>
                    <div className='modal_rowsection'>
                        <button
                            className='modal_button'
                            onClick={handleClose}
                        >
                            Close Register
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    function SalesInvoices() {
        const addInvoice = (projectuserid, projectid, timestamp, clientid, subaccountid, currencyid, name, items, amount, setLoading, setResult) => {
            console.log('Trying to add sales invoice');

            if (!clientid || !currencyid || !name) {
                setResult('Missing info')
                return
            }

            for (let item of items) {
                if (!item.accounttype || !item.accountid) {
                    setResult('Missing account type or account id in items');
                    return;
                }
            }

            setLoading(true);

            const trimmedname = name.trim();

            const data = {
                projectuserid: projectuserid,
                projectid: projectid,
                ts: timestamp,
                clientid: clientid,
                subaccountid: subaccountid,
                currencyid: currencyid,
                name: trimmedname,
                items: items,
                amount: amount
            }

            axios.post(configData.CONTROLLERURL + configData.ADDSALESINVOICE, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Add sales invoice data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        data.id = res.data.id;
                        dispatch({
                            type: 'ADD_SALESINVOICE',
                            salesinvoice: data
                        });
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error')
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }
        const accountTypes = [
            { id: 'liability', name: 'Liability' },
            { id: 'item', name: 'Item' },
        ];
        function NewItem({ item, index, handleTypeChange, handleAccountChange, handleDescriptionChange, handleQtyChange, handleUnitPriceChange, handleRemoveItem }) {
            const renderAccountOptions = () => {
                switch (item.accounttype) {
                    case 'asset':
                        return <Select data={project.assetaccounts} itemid={item.accountid} setItemid={(accountId) => handleAccountChange({ target: { value: accountId } }, index)} />;
                    case 'liability':
                        return <Select data={project.liabilityaccounts} itemid={item.accountid} setItemid={(accountId) => handleAccountChange({ target: { value: accountId } }, index)} />;
                    case 'equity':
                        return <Select data={project.equityaccounts} itemid={item.accountid} setItemid={(accountId) => handleAccountChange({ target: { value: accountId } }, index)} />;
                    case 'income':
                        return <Select data={project.incomeaccounts} itemid={item.accountid} setItemid={(accountId) => handleAccountChange({ target: { value: accountId } }, index)} />;
                    case 'expense':
                        return <Select data={project.expenseaccounts} itemid={item.accountid} setItemid={(accountId) => handleAccountChange({ target: { value: accountId } }, index)} />;
                    case 'client':
                        return <Select data={project.clients} itemid={item.accountid} setItemid={(clientId) => handleAccountChange({ target: { value: clientId } }, index)} />;
                    case 'supplier':
                        return <Select data={project.suppliers} itemid={item.accountid} setItemid={(supplierId) => handleAccountChange({ target: { value: supplierId } }, index)} />;
                    case 'staff':
                        return <Select data={project.staff} itemid={item.accountid} setItemid={(accountId) => handleAccountChange({ target: { value: accountId } }, index)} />;
                    case 'item':
                        return <Select data={project.items} itemid={item.accountid} setItemid={(accountId) => handleAccountChange({ target: { value: accountId } }, index)} />;
                    case 'cash':
                        return <Select data={project.cashaccounts} itemid={item.accountid} setItemid={(accountId) => handleAccountChange({ target: { value: accountId } }, index)} />;
                    default:
                        return null;
                }
            };

            return (
                <tr key={'item' + index}>
                    <td>
                        <Select data={accountTypes} itemid={item.accounttype} setItemid={(accountId) => handleTypeChange({ target: { value: accountId } }, index)} />
                    </td>
                    <td>
                        {renderAccountOptions()}
                    </td>
                    <td>
                        <input
                            className='modal_input'
                            type="text"
                            placeholder="Description"
                            value={item.itemdescription}
                            onChange={(e) => handleDescriptionChange(e, index)}
                        />
                    </td>
                    <td>
                        <input
                            className='modal_input'
                            type="number"
                            placeholder="Qty"
                            value={item.itemquantity}
                            onChange={(e) => handleQtyChange(e, index)}
                        />
                    </td>
                    <td>
                        <input
                            className='modal_input'
                            type="number"
                            placeholder="Unit Price"
                            value={item.itemprice}
                            onChange={(e) => handleUnitPriceChange(e, index)}
                        />
                    </td>
                    <td>
                        {(Number(item.itemquantity || 0) * Number(item.itemprice || 0)).toFixed(2)}
                    </td>
                    <td>
                        <div className='modal_removeitembutton' onClick={() => handleRemoveItem(index)}>X</div>
                    </td>
                </tr >
            );
        }

        const [selecteddate, setSelecteddate] = useState(new Date());
        const [timestamp, setTimstamp] = useState(0);

        const [subaccountid, setSubaccountid] = useState('');
        const [clientid, setClientid] = useState('');

        const [items, setItems] = useState([{ accounttype: '', accountid: '', itemdescription: '', itemprice: '', itemquantity: '' }]);
        const [name, setName] = useState('');
        const [currencyid, setCurrencyid] = useState('');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            const unixTimestamp = Math.floor(selecteddate.getTime() / 1000);
            setTimstamp(unixTimestamp);
        }, [selecteddate]);

        const handleAddItem = () => {
            setItems([...items, {}])
        };

        const handleRemoveItem = () => {
            if (items.length > 1) {
                const updatedItems = items.slice(0, items.length - 1);
                setItems(updatedItems);
            }
        };

        const handleTypeChange = (event, index) => {
            const selectedItem = event.target.value;
            const updatedItems = [...items];
            updatedItems[index].accounttype = selectedItem;
            setItems(updatedItems);
        };

        const handleAccountChange = (event, index) => {
            const selectedItem = event.target.value;
            const updatedItems = [...items];
            updatedItems[index].accountid = selectedItem;
            setItems(updatedItems);
        };

        const handleDescriptionChange = (event, index) => {
            const selectedItem = event.target.value;
            const updatedItems = [...items];
            updatedItems[index].itemdescription = selectedItem;
            setItems(updatedItems);
        };

        const handleQtyChange = (event, index) => {
            const selectedQty = event.target.value;
            const updatedItems = [...items];
            updatedItems[index].itemquantity = selectedQty;
            setItems(updatedItems);
        };

        const handleUnitPriceChange = (event, index) => {
            const selectedUnitPrice = event.target.value;
            const updatedItems = [...items];
            updatedItems[index].itemprice = selectedUnitPrice;
            setItems(updatedItems);
        };

        const amount = isNaN(items.reduce((sum, item) => sum + ((item.itemprice || 0) * item.itemquantity), 0)) ? 0 : items.reduce((sum, item) => sum + ((item.itemprice || 0) * item.itemquantity), 0)

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Date</div>
                        </div>
                        <div className='modal_rowsection'>
                            <DatePicker
                                className='modal_datepicker'
                                selected={selecteddate}
                                onChange={(date) => setSelecteddate(date)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Subaccount</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.subaccounts} itemid={subaccountid} setItemid={setSubaccountid} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Currency</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.currencies} itemid={currencyid} setItemid={setCurrencyid} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Client</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.clients} itemid={clientid} setItemid={setClientid} />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Description</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                placeholder=""
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Account</th>
                                        <th>Description</th>
                                        <th>Qty</th>
                                        <th>Unit price</th>
                                        <th>Total</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        items.map((item, index) => (
                                            <NewItem
                                                key={'item' + index}
                                                item={item}
                                                index={index}
                                                handleTypeChange={handleTypeChange}
                                                handleAccountChange={handleAccountChange}
                                                handleDescriptionChange={handleDescriptionChange}
                                                handleQtyChange={handleQtyChange}
                                                handleUnitPriceChange={handleUnitPriceChange}
                                                handleRemoveItem={handleRemoveItem}
                                            />
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>Balance due</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{project.currencies.find(item => item.id === currencyid, 10)?.symbol || ''} {amount}</td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className="modal_button" onClick={handleAddItem}>Add item</div>
                        </div>
                        <div className='modal_buttoncontainer'></div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => addInvoice(project.projectuserid, project.projectid, timestamp, clientid, subaccountid, currencyid, name, items, amount, setLoading, setResult)} disabled={loading}>{loading ? 'Loading...' : 'Save'}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function KitchenDisplay() {
        const [orders, setOrders] = useState([
            { id: 1, table: 5, items: ['Burger', 'Fries'], status: 'New' },
            { id: 2, table: 2, items: ['Salad', 'Soup'], status: 'New' },
            { id: 3, table: 1, items: ['Pizza'], status: 'In Progress' },
        ]);

        const updateStatus = (id, newStatus) => {
            setOrders(prev =>
                prev.map(order =>
                    order.id === id ? { ...order, status: newStatus } : order
                )
            );
        };

        const statusCategories = ['New', 'In Progress', 'Completed'];

        return (
            <div style={{ display: 'flex', gap: '20px', padding: '20px' }}>
                {statusCategories.map(status => (
                    <div key={status} style={{ flex: 1, border: '1px solid #ccc', borderRadius: '8px', padding: '10px' }}>
                        <h2>{status}</h2>
                        {orders
                            .filter(order => order.status === status)
                            .map(order => (
                                <div key={order.id} style={{ borderBottom: '1px solid #eee', marginBottom: '10px', paddingBottom: '10px' }}>
                                    <strong>Table {order.table}</strong>
                                    <ul>
                                        {order.items.map((item, i) => (
                                            <li key={i}>{item}</li>
                                        ))}
                                    </ul>
                                    {status !== 'Completed' && (
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {status !== 'In Progress' && (
                                                <button onClick={() => updateStatus(order.id, 'In Progress')}>Start</button>
                                            )}
                                            <button onClick={() => updateStatus(order.id, 'Completed')}>Complete</button>
                                        </div>
                                    )}
                                </div>
                            ))}
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className='pos'>
            <Title text='POS' />
            <div>
                <h2>{navItems.find(i => i.key === module)?.label}</h2>
                {renderModule()}
            </div>
            <POSNavBar module={module} setModule={setModule} />
        </div>
    );
}

export default POS;